import { Link } from 'react-router-dom'
import { Icon } from '../Icon'
import { useVirtualKeyboardOpen } from './useVirtualKeyboardOpen'
import './nav.css'

export interface NavigationBarDestination { id: string; to: string; label: string; icon: string; badge?: number | undefined }

/**
 * Navigation bar M3 Expressive (compact, 64): 3-5 destinazioni, etichette sempre visibili, indicatore a pillola,
 * icona piena sulla destinazione attiva. L'ultima voce, "Menu", apre la modal expanded rail.
 */
export function NavigationBar({
  destinations, activeId, onMenu, menuOpen,
}: {
  destinations: NavigationBarDestination[]
  activeId: string | null
  onMenu: () => void
  menuOpen: boolean
}) {
  const hidden = useVirtualKeyboardOpen()
  if (hidden) return null
  return (
    <nav className="md-navbar" aria-label="Navigazione principale">
      {destinations.map(d => {
        const active = d.id === activeId
        return (
          <Link key={d.id} to={d.to} className="md-navbar__dest md-state" data-active={active} aria-current={active ? 'page' : undefined}>
            <span className="md-navbar__indicator">
              <Icon name={d.icon} size={24} filled={active} />
              {d.badge ? <span className="md-navbar__badge" aria-hidden="true">{d.badge > 99 ? '99+' : d.badge}</span> : null}
            </span>
            <span className="md-navbar__label">{d.label}</span>
          </Link>
        )
      })}
      <button type="button" className="md-navbar__dest md-state" aria-haspopup="dialog" aria-expanded={menuOpen} onClick={onMenu}>
        <span className="md-navbar__indicator"><Icon name="menu" size={24} /></span>
        <span className="md-navbar__label">Menu</span>
      </button>
    </nav>
  )
}
